export default function PageCardImage({ src, alt }) {
  return (
    <div className="page-card__image-wrap">
      <img src={src} alt={alt} className="page-card__image" loading="lazy" />
    </div>
  )
}
